/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdirecoveryList.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edirecovery-list";

export class AutogenModelEdirecoveryList<RowType extends ModelRow> extends Endpoint<RowType, RowEdirecoveryListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdirecoveryList extends ModelRow<RowEdirecoveryListFields> {
	constructor(values?: Partial<RowEdirecoveryListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdirecoveryListFields {
	alt_partner_id: string;
	batch: number;
	company_id: string;
	create_date: Date;
	direction: string;
	edi_log_id: string;
	filename: string;
	id: string;
	orig_profile_id: string;
	orig_trans_type: string;
	outage: string;
	partner_id: string;
	total_func_grps: number;
	transaction_type: string;
	version: string;
}

